export function isJSONString(v: unknown): v is string {
  try {
    const obj = JSON.parse(v as string);
    return Boolean(obj) && typeof obj === 'object';
  } catch {
    return false;
  }
}
